import React, { useState, useEffect } from 'react'
import { 
  Nav, NavItem, NavLink,
  TabContent, TabPane,
  Label 
} from 'reactstrap'
import _ from 'lodash'
import ReactTable from 'react-table'
import Moment from 'moment'
import classnames from 'classnames'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import Lang from 'Lang/General'

const ViewIndividualResultModal = props => {
  let {
    individualResult,
    lang
  } = props
  const [ activeTab, setActiveTab ] = useState( 0 )
  const [ pageValuesCollection, setPageValuesCollection ] = useState( [] )

  useEffect( () => {
    if ( !_.isEmpty( individualResult ) ) {
      InitialiseFormResults( 
        individualResult, 
        setPageValuesCollection,
        setActiveTab,
        lang,
        props.downloadSelectedDofMedia
      )
    }
  }, [ individualResult ])

  const renderPageName = ( page ) => {
    let pageName = page[ 'name' ][ lang ].replace(/<\/?[^>]+(>|$)/g, "")
    if ( pageName != "" && pageName != Lang[ 'PAGE' ][ lang ] ) {
      return pageName 
    } else {
      return `${ Lang[ 'PAGE' ][ lang ] } ${ page.number }`
    }
  }

  return (
    <>
      <Label style={{ paddingBottom: "15px" }} >
        { Lang[ 'SUBMITTED_FROM' ][ lang ] }{ individualResult.center_name }
      </Label>
      <Nav tabs={true}>
        {
          pageValuesCollection.map( ( page ) => {
            return (
              <NavItem>
                <NavLink href="javascript:void(0);"
                  className={classnames({ active: activeTab === page.id })}
                  onClick={() => setActiveTab( page.id ) } >
                  { renderPageName( page ) }
                </NavLink>
              </NavItem>
            )
          })
        }
      </Nav>
      <TabContent activeTab={ activeTab }>
        {
          pageValuesCollection.map( ( page ) => {
            return (
              <TabPane tabId={ page.id }>
                <ReactTable
                  defaultPageSize={ 10 }
                  showPagination={ true }
                  nextText={ Lang[ 'NEXT_PAGE' ][ lang ]}
                  previousText={ Lang[ 'PREVIOUS' ][ lang ]}
                  pageText={ Lang[ 'PAGE' ][ lang ]}
                  rowsText={ Lang[ 'ROWS' ][ lang ]}
                  NoDataComponent={ () => <span></span> }
                  data={ page.values.filter( val => !_.isEmpty( val.value ) ) }
                  columns={[
                    {
                      Header: Lang[ 'LABEL' ][ lang ],
                      accessor: 'dataLabel',
                      width: Math.round( window.innerWidth * 0.3 ),
                      Cell: ({ value }) => <div style={{ wordBreak: "break-all" }}>{ value }</div>
                    },
                    {
                      Header: Lang[ 'VALUE' ][ lang ],
                      accessor: 'value'
                    }
                  ]}/>
              </TabPane>
            )
          })
        }
      </TabContent>
      { props.onLoadDownloadFormDataHOC && <LoadingOverlay /> }
    </>
  )
}

const InitialiseFormResults = ( 
  individualResult, 
  setPageValuesCollection, 
  setActiveTab, 
  lang,
  downloadSelectedDofMedia
) => {
  let values = _.cloneDeep( individualResult.values.filter( val => !_.isEmpty( val.value ) ) )
  let pageValuesMappings = _.groupBy( values, 'page' )
  let pages = _.map( 
    pageValuesMappings, 
    ( pageValues, page ) => {
      const tmpPageValues = pageValues.map( value => {
        let formValue

        if ( value.dataLabel === 'DELIVERY_REMARK' ) {
          value.dataLabel = Lang[ 'REMARK' ][ lang ]
        } else {
          let domOfValue = getDomOfValue( individualResult, value )
          if ( _.isEmpty( domOfValue ) || _.isEmpty( domOfValue.label[ lang ] ) ) {
            value.dataLabel = value.dataLabel
          } else {
            value.dataLabel = processFieldLabel( domOfValue.label[ lang ] ) 
          }
        }

        if ( typeof value.value === 'string' ) {
          if ( value.type === 'inputFile' ) {
            formValue = (
              <a 
                href={ value.value }
                style={{ overflow: "hidden" }} 
                onClick={ e => {
                  e.preventDefault()
                  downloadSelectedDofMedia( value.value ) 
                }} >
                { value.value }
              </a>
            )
          } 
          else if ( value.type === 'dateField' ) {
            formValue =  Moment( value.value ).format( 'YYYY-MM-DD' )
          } 
          else if ( value.type === 'radio' ) {
            let domOfValue = getDomOfValue( individualResult, value )
            let label = value.value
            if ( !_.isEmpty( domOfValue ) && !_.isEmpty( domOfValue.selections ) ) {
              formValue =  getRadioSelectionLabelByValue( 
                domOfValue, 
                value, 
                lang,
                pageValuesMappings[ page ],
                downloadSelectedDofMedia
              )
            } else {
              formValue = label
            }
          } 
          else {
            formValue = value.value
          }
        } else {
          if ( value.type === 'checkbox' ) {
            let domOfValue = getDomOfValue( individualResult, value )
            let labels = value.value
            if ( !_.isEmpty( domOfValue ) && !_.isEmpty( domOfValue.selections ) ) {
              labels = getCheckboxSelectionLabelByValue( 
                domOfValue, 
                value, 
                lang, 
                pageValuesMappings[ page ],
                downloadSelectedDofMedia
              )
            }
            formValue = (
              <ul className='pl-3 m-0'>
                {
                  labels.map( item => {
                    return item
                  })
                }
              </ul>
            )
          } else { 
            formValue = (
              <ul style={{ margin: "0px" }}>
                {
                  value.value.map( item => {
                    if ( value.type === 'inputFile' ) {
                      return (
                        <li>
                          <a 
                            href={ item.url }
                            style={{ overflow: "hidden" }} 
                            onClick={ e => {
                              e.preventDefault()
                              downloadSelectedDofMedia( item.url, item.filename ) 
                            }} >
                            { item.filename }
                          </a>
                        </li> 
                      )
                    } else {
                      return <li>{ item }</li> 
                    }
                  })
                }
              </ul>
            )
          }
        }
        value.value = formValue
        return value
      })

      if ( page != 'undefined' ) {
        return {
          id: page,
          number: page,
          name: individualResult.current_digital_order_form.content[0].children[ parseInt( page ) - 1 ].name,
          values: _.filter( tmpPageValues, value => !_.isEmpty( value ) && !value.isDependentFieldExtracted )
        }
      } else {
        return {
          id: 'REMARKS',
          name: Lang[ 'REMARKS' ],
          values: _.filter( tmpPageValues, value => !_.isEmpty( value ) && !value.isDependentFieldExtracted )
        }
      }
    }
  )

  setPageValuesCollection( pages )
  if ( pages.length > 0 ) {
    setActiveTab( pages[0].id )
  } 
}

const getDomOfValue = ( individualResult, value ) => {
  let pageDom = individualResult.current_digital_order_form.content[0].children[ parseInt( value.page ) - 1 ]
  let dom = searchDomWithId( pageDom, value.id )
  return dom
}

const processFieldLabel = label => {
  label = label.split( "</p>" )[ 0 ]
  label = label.split( "</div>" )[ 0 ]
  label = label.split( "<br" )[ 0 ]
  label = label.replace( /<[^>]+>/g, '' ).replace( /&nbsp;/g, "" )  
  return label
}

const searchDomWithId = ( dom, targetId ) => {
  let foundDom = {}
  if ( _.isEmpty( dom ) || dom.id == targetId ) {
    return dom
  }
  else if ( !_.isEmpty( dom.children ) ) {
    for ( let i = 0; i < dom.children.length; i++ ) {
      let tmpDom = searchDomWithId( dom.children[i], targetId )
      if ( !_.isEmpty( tmpDom ) ) {
        foundDom = tmpDom
        break
      }
    }
  } 
  else if ( ["Radio", "RadioFlexible", "Checkbox", "CheckboxFlexible"].indexOf( dom.type ) !== -1 && !_.isEmpty( dom.selections )) {
    for ( let i = 0; i < dom.selections.length; i++ ) {
      let selection = dom.selections[i]
      if ( !_.isEmpty( selection.dependentField ) ) {
        if ( selection.dependentField.id == targetId ) {
          foundDom = selection.dependentField
          break
        }
      }
    }
  }
  return foundDom
}

const getRadioSelectionLabelByValue = ( dom, value, lang, currentPageValues, downloadSelectedDofMedia ) => {
  if ( !_.isEmpty( value.flexibleInputValue ) ) {
    return <div style={{ whiteSpace: "pre-line" }}>{ value.flexibleInputValue }</div>
  } else {
    for ( let i = 0; i < dom.selections.length; i++ ) {
      if ( dom.selections[ i ].value == value.value ) {
        let selectionDependentFieldIndex = (
          ( 
            !_.isEmpty( dom.selections[ i ].dependentField ) && 
            _.findIndex( currentPageValues, { id: dom.selections[ i ].dependentField.id } ) 
          ) ||
          -1
        )

        if( selectionDependentFieldIndex > -1 ){
          currentPageValues[ selectionDependentFieldIndex ].isDependentFieldExtracted = true
        }

        return (
          <div style={{ whiteSpace: "pre-line" }}>
            { dom.selections[ i ].label[ lang ] }
            {
              selectionDependentFieldIndex > -1 ? (
                <p>
                  { `${ dom.selections[ i ].dependentField.label[ lang ] }: ` } 
                  { 
                    typeof currentPageValues[ selectionDependentFieldIndex ].value === 'string' ? (
                      currentPageValues[ selectionDependentFieldIndex ].value 
                    ) : (
                      <a 
                        href={ currentPageValues[ selectionDependentFieldIndex ].value[ 0 ].url }
                        style={{ overflow: "hidden" }} 
                        onClick={ e => {
                          e.preventDefault()
                          downloadSelectedDofMedia( e.currentTarget.href, e.currentTarget.textContent ) 
                        }} >
                        { currentPageValues[ selectionDependentFieldIndex ].value[ 0 ].filename }
                      </a>
                    ) 
                  }
                </p>
              ) : (
                <></>
              )
            }
          </div>
        )
      }
    }
  }
}

const getCheckboxSelectionLabelByValue = ( checkboxDom, checkboxValue, lang, currentPageValues, downloadSelectedDofMedia ) => {
  let dom = _.cloneDeep( checkboxDom )
  let value = _.cloneDeep( checkboxValue )
  let labels = []
  let index

  dom.selections.map( ( selection ) => {
    let selectionDependentFieldIndex = (
      ( 
        !_.isEmpty( selection.dependentField ) && 
        _.findIndex( currentPageValues, { id: selection.dependentField.id } ) 
      ) ||
      -1
    )

    if( selectionDependentFieldIndex > -1 ){
      currentPageValues[ selectionDependentFieldIndex ].isDependentFieldExtracted = true
    }

    index = value.value.indexOf( selection.value )
    if ( index >= 0 ) {
      value.value.splice( index, 1 )
      labels.push( 
        <li>
          { selection.label[ lang ] }
          {
            !_.isEmpty( selection.nestedSelections ) ? (
              <ul className='pl-3' >
                {
                  selection.nestedSelections.map( nestedSelection => {
                    index = value.value.indexOf( nestedSelection.value )
                    index > -1 && value.value.splice( index, 1 )
                    return index > -1 ? (
                      <li>
                        { nestedSelection.label[ lang ] }
                        {
                          !_.isEmpty( nestedSelection.subCheckboxes ) ? (
                            <ul className='pl-3' >
                              {
                                nestedSelection.subCheckboxes.map( subselection => {
                                  index = value.value.indexOf( subselection.value )
                                  index > -1 && value.value.splice( index, 1 )
                                  return index > -1 ? (
                                    <li>{ subselection.label[ lang ] }</li>
                                  ) : (
                                    <></>
                                  )
                                })
                              }
                            </ul>
                          ) : (
                            <></>
                          )
                        }
                      </li>
                    ) : (
                      <></>
                    )
                  })
                }
              </ul>
            ) : (
              <></>
            )
          }
          {
            selectionDependentFieldIndex > -1 ? (
              <ul className='pl-3' >
                <li>
                  { `${ selection.dependentField.label[ lang ] }: ` }
                  { 
                    typeof currentPageValues[ selectionDependentFieldIndex ].value === 'string' ? (
                      currentPageValues[ selectionDependentFieldIndex ].value 
                    ) : (
                      <a 
                        href={ currentPageValues[ selectionDependentFieldIndex ].value[ 0 ].url }
                        style={{ overflow: "hidden" }} 
                        onClick={ e => {
                          e.preventDefault()
                          downloadSelectedDofMedia( e.currentTarget.href, e.currentTarget.textContent )
                        }} >
                        { currentPageValues[ selectionDependentFieldIndex ].value[ 0 ].filename }
                      </a>
                    ) 
                  }
                </li>
              </ul>
            ) : (
              <></>
            )
          }
        </li> 
      )
    }
  })

  if ( !_.isEmpty( value.flexibleInputValue ) ) {
    labels.push( <li>{ value.flexibleInputValue }</li> )
    let flexibleOptionValue = value.flexibleInputValue.replaceAll( ' ', '-' )
    index = value.value.indexOf( flexibleOptionValue )
    value.value.splice( index, 1 )
  }

  return [ ...labels, ...value.value ]
}

export default ViewIndividualResultModal